import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	explainWhatProjectRestoreDoesPart1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmExplainWhatProjectRestoreDoes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmLearnMoreAboutTrashAndRestore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	explainWhatProjectRestoreDoesPart1: {
		id: 'project-restore-modal.modal-message.explain-what-project-restore-does-part-1',
		defaultMessage:
			'The project along with its issues, Jira components, attachments, and versions will be restored.',
		description: 'Explanation for restoring a project',
	},
	jsmExplainWhatProjectRestoreDoes: {
		id: 'project-restore-modal.modal-message.jsm-explain-what-project-restore-does',
		defaultMessage:
			'Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal.',
		description: 'Explanation for restoring a project',
	},
	jsmLearnMoreAboutTrashAndRestore: {
		id: 'project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore',
		defaultMessage: 'Learn more about trash and restore.',
		description: 'Link to In project help (IPH) to learn more about trash and restore',
	},
	explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
		id: 'project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh',
		defaultMessage:
			'The project along with its work items, Jira components, attachments, and versions will be restored',
		description: 'Explanation for restoring a project',
	},
	jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
		id: 'project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh',
		defaultMessage:
			'Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal.',
		description: 'Explanation for restoring a project',
	},
	explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia: {
		id: 'project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh-galaxia',
		defaultMessage:
			'The space along with its work items, Jira components, attachments, and versions will be restored',
		description: 'Explanation for restoring a project',
	},
	jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia: {
		id: 'project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh-galaxia',
		defaultMessage:
			'Once restored, this service space will appear in directories and its work items will appear in search results. You may need to turn on email support for this service space to work as normal.',
		description: 'Explanation for restoring a project',
	},
});
export default messages;
